import React from 'react';
import styles from './Homeservice.module.css';
import { Link } from 'react-router-dom';

const services = [
  { icon: '📱', title: 'Digital Marketing', desc: 'SEO, PPC, social media & content marketing — data-driven campaigns built for maximum ROI and brand visibility.', link: '/digital' },
  { icon: '🏙️', title: 'OOH Media Planning', desc: "Strategic billboards, hoardings & transit displays placed where Pune's audience can't miss your brand.", link: '/oohmedia' },
  { icon: '📺', title: 'ATL Media Planning', desc: 'TV, radio & print advertising — mass-reach strategies that build powerful brand awareness across Maharashtra.', link: '/atlmedia' },
  { icon: '🎯', title: 'BTL Media Planning', desc: 'Direct mail, in-store promotions & experiential marketing that convert targeted audiences into loyal customers.', link: '/btlmedia' },
  { icon: '🚌', title: 'Transit Media', desc: "Bus wraps, auto rickshaw ads & metro branding — maximum visibility for Pune's daily commuters.", link: '/transitmedia' },
  { icon: '📻', title: 'TVC, Print & Radio', desc: 'End-to-end production for TV Commercials, newspaper ads & radio spots — complete solutions under one roof.', link: '/tvcmedia' },
  { icon: '🎪', title: 'Event Management', desc: 'From product launches to large-scale exhibitions — we conceptualise, plan and execute unforgettable brand events.', link: '/event' },
  { icon: '🎬', title: 'Film Production', desc: 'Professional scripting, direction, shooting and post-production — cinematic brand stories that convert viewers.', link: '/filmproduction' },
  { icon: '🖨️', title: 'Offset Designing & Printing', desc: 'Premium brochures, banners, packaging and stationery — designed to perfection, printed with the finest quality.', link: '/offsetdesigning' },
  { icon: '🎁', title: 'Corporate Gifting', desc: 'Curated branded merchandise & executive gifts that leave a lasting impression on clients and partners.', link: '/corporategifting' },
];

const Homeservice = () => {
  return (
    <section className={styles.homeservice} aria-label="Our 360° Marketing Services">

      {/* Section Header */}
      <div className={styles.homeservice_heading}>
        <span className={styles.eyebrow}>What We Do Best</span>
        <h2>
          360° Marketing Services
          <span> Built for Growth</span>
        </h2>
        <p>
          As the best marketing company in Pune, we offer a complete suite of advertising
          and marketing services — everything your brand needs to dominate the market.
        </p>
      </div>

      {/* Services Grid */}
      <div className={styles.services_grid}>
        {services.map((s, i) => (
          <Link to={s.link} key={i} className={styles.service_card}>
            <div className={styles.card_icon}>
              <span>{s.icon}</span>
            </div>
            <h3 className={styles.card_title}>{s.title}</h3>
            <p className={styles.card_desc}>{s.desc}</p>
            <div className={styles.card_cta}>
              Explore
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </div>
          </Link>
        ))}
      </div>

      {/* Bottom CTA */}
      <div className={styles.bottom_cta}>
        <p>Not sure which service fits your brand?</p>
        <Link to="/contact" className={styles.cta_btn}>
          Get a Free Strategy Call →
        </Link>
      </div>

    </section>
  );
};

export default Homeservice;